import React from 'react';
import { useIntl } from 'react-intl';
import { ApiFilterOperation, Evidence } from '@eas/common-web';
import { EsFileState } from '@enums';
import { useInfFiles } from '../inf-files';
import { useColumns } from './inf-file-new-columns';

export const INF_FILES_NEW_IDENTIFIER = 'INF_FILES_NEW';
export const INF_FILES_NEW_VERSION = 7;

export function InfFilesNew() {
  const intl = useIntl();

  const columns = useColumns();

  const { evidenceBag } = useInfFiles({
    evidenceProps: {
      identifier: INF_FILES_NEW_IDENTIFIER,
      version: INF_FILES_NEW_VERSION,
      tableProps: {
        columns,
        defaultPreFilters: [
          {
            field: 'state.id',
            operation: ApiFilterOperation.EQ,
            value: EsFileState.NEW,
          },
        ],
        tableName: intl.formatMessage({
          id: 'ES__INF_FILES_NEW__TABLE__TITLE',
          defaultMessage: 'Spisy INF - Nové spisy',
        }),
      },
    },
  });

  return <Evidence {...evidenceBag} />;
}
